<template>
  <v-dialog
      fullscreen
      eager
      v-model="dialog"
      hide-overlay
      content-class="form-dialog"
  >
    <v-card elevation="0">
      <v-col class="text-right px-4">
        <v-btn icon @click="closeDialog" ><v-icon large color="primary">close</v-icon></v-btn>
      </v-col>

      <v-card-text>
        <v-form ref="form">
          <v-row justify="space-around">
            <v-col cols="12" md="5">
              <h3 class="font-weight-bold">{{ $t('buttons:add-specific', { specific: $t('common:role')}) }}</h3>

              <v-row class="mb-3">
                <v-col cols="6" style="height: 86px;">
                  <UserTypeAhead
                      ref="userTypeahead"
                      :value="data.users"
                      @input="data.users = $event"
                      is-required
                      :label="$t('common:user')"
                      tabindex="73"
                      @onAddClick="registerNewUser"
                  />
                </v-col>
                <v-col cols="6" align-self="center">
                  <v-btn outlined color="primary" route :to="`/${this.$store.state.manager.settingsModuleUrl}/profile/customer/users`" v-if="isMain">
                    <v-icon>add</v-icon>
                    <span class="d-none d-sm-block">{{ $t('book/facility:facility.dashboard.information.roles.add-user') }}</span>
                  </v-btn>
                </v-col>
              </v-row>

              <v-select
                  outlined
                  v-model="data.role"
                  :label="$t('common:role')"
                  :menu-props="{ bottom: true, offsetY: true }"
                  :items="restRoles"
                  item-text="name"
                  item-value="id"
                  :rules="[ruleRequired($t('utils:rules.required'))]"
                  tabindex="74"
              />

              <v-text-field
                  outlined
                  v-model="data.rank"
                  :rules="[ruleRequired($t('utils:rules.required'))]"
                  :label="$t('common:rank')"
                  type="number"
                  tabindex="75"
              />

              <BaseButton
                  color="primary"
                  :btnText="$t('buttons:add-specific', { specific: $t('common:role')})"
                  @clickedButton="saveAssignment()"
              />

              <DirtyConfirmButtonDialog
                  ref="dirtyDialog"
                  :btn-text="$t('buttons:cancel')"
                  color="grey"
                  :dialog-title="$t('dialog:dirty-save-btn-title')"
                  :dialog-text="$t('dialog:dirty-save-btn-dialog')"
                  :button1-text="$t('dialog:dirty-save-btn-1-text')"
                  :button2-text="$t('dialog:dirty-save-btn-2-text')"
                  @clickedButton="closeDialog"
                  :dataToWatch="data"
                  hideOverlay
              />
            </v-col>
            <v-col class="d-none d-md-block" md="5"></v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>

    <MinimizedUsersDialogForm @onRegistered="setRegisteredUser" ref="usersDialogForm"/>
  </v-dialog>
</template>
<script>

import FacilityUserAssignmentService from "@/modules/book/services/facility-user-assignment-service";
import WorkerRoleService from "@/modules/core/services/worker-role-service";

import Utils from "@/modules/core/services/utils";
import DataUtils from "@/modules/core/services/data-utils";
import {ruleRequired} from "@/modules/core/services/rules";

import WorkerRole from "@/modules/core/data/worker-role"
import FacilityUserAssignment from "@/modules/book/data/facility-user-assignment";

import DirtyConfirmButtonDialog from "@/modules/core/components/TwoButtonDialog/DirtyConfirmButtonDialog";
import BaseButton from "@/modules/core/components/Base/BaseButton";
import UserTypeAhead from "@/modules/core/components/UserTypeAhead";
import MinimizedUsersDialogForm from "@/modules/core/components/MinimizedUsersDialogForm";

import {mapGetters} from 'vuex';

export default {
  name: 'FacilityRoleDialogForm',
  components: {
    DirtyConfirmButtonDialog,
    BaseButton,
    UserTypeAhead,
    MinimizedUsersDialogForm
  },
  data() {
    return {
      data: new FacilityUserAssignment(),

      restUsers: [],
      restRoles: [],
      tableOptions: [],
      tableSearch: [],
      dialog: false
    }
  },
  methods: {
    saveAssignment() {
      if (!this.$refs.form.validate()) {
        Utils.showWarningSnackbar(this.$t('snackbar:empty-fields'))
        return;
      }

      this.data.facility = this.$route.params.id;

      FacilityUserAssignmentService.postToAPI(this.data,
        () => {
          Utils.showSuccessSnackbar(this.$t('snackbar:add-success', {name: this.$t('common:role')}));
          this.$emit('updateRoleData', this.tableOptions, this.tableSearch);
          this.closeDialog()
        },
        (serviceName, error) => {
          if (error.response.headers.error_cause && this.$t('error_causes:' + error.response.headers.error_cause)) {
            Utils.showFailureSnackbar(this.$t("error-causes:" + error.response.headers.error_cause));
          } else {
            Utils.showFailureSnackbar(this.$t('snackbar:add-failure', {name: this.$t('common:role')}))
          }

          this.$logger.error(serviceName + "Could not post facility user assignment because: " + error);
        }
      );
    },
    closeDialog() {
      this.dialog = false;
      this.$refs.form.reset();
    },

    addRole(options, search) {
      this.tableOptions = options;
      this.tableSearch = search;
      this.dialog = true;
    },
    ruleRequired,

    registerNewUser(name) {
      this.$refs.usersDialogForm.openDialogWithName(name);
    },

    setRegisteredUser(item) {
      this.restUsers.push(item);
      this.$refs.userTypeahead.initWithoutFetch(item);
    },
  },
  computed: {
    ...mapGetters('auth', ['isOperator', 'isManager', 'isMain']),
    currentLang() {
      return this.$store.state.translation.language;
    },
  },
  watch: {
    currentLang() {
      Utils.sleep(500).then(() => {
        this.$refs.form.resetValidation()
      });
    },
    dialog() {
      // if dialog opens, load data and set data watcher
      if(this.dialog) {
        WorkerRoleService.readAllFromAPI(
          (resp) => {
            var response = DataUtils.parseDataToObjectArray(resp.data, WorkerRole);
            if (response == null) {
              this.$router.go(-1);
            } else {
              this.restRoles = response;
            }
          },
          (error) => {
            this.$logger.error(error);
            Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('common:role_plural')}))
          }
        )

        this.$refs.dirtyDialog.startWatch();
      }
    }
  }
}
</script>
